import { useTranslation } from '../../i18n/i18n';
import { useCms } from '../../state/api';
import { Res } from '../../state/api-resources';
import { AccountPageNavigation } from '../AccountPageNavigation/AccountPageNavigation';
import { CheckmarkList } from '../CheckmarkList/CheckmarkList';
import { CmsComponent } from '../cms/CmsComponent';
import { ContentCard } from '../ContentCard/ContentCard';
import { Icon, gift } from '../Icon/Icon';
import { Main } from '../Main/Main';

export const BonusLoggedOut = () => {
	const t = useTranslation().bonusPage;

	const { data: description, isLoading: isLoadingDescription } = useCms(Res.cmsComponent, {
		slug: 'bonus-description',
	});
	const { data: pitch, isLoading: isLoadingPitch } = useCms(Res.cmsComponent, { slug: 'bonus-pitch' });

	return (
		<Main>
			<AccountPageNavigation />
			<div id="bonus-page">
				<h1 className="big">{t.bonus}</h1>
				<div className="bonus-register-cards-grid">
					<ContentCard className="register">
						<div style={{ maxWidth: '40rem' }}>
							<h2>{t.registerAsBonusCustomer}</h2>
							<p>{t.registerAsBonusCustomerCopy}</p>
							<CheckmarkList className="black compact">
								<li>{t.registerChecklistA}</li>
								<li>{t.registerChecklistB}</li>
								<li>{t.registerChecklistC}</li>
							</CheckmarkList>
						</div>
					</ContentCard>
					<div className="bonus-box">
						<ContentCard className="bonus-wallet">
							<Icon shape={gift} size={100} />
							<h2>{t.becomeBonusCustomerToday}</h2>
						</ContentCard>
					</div>
				</div>
				{!isLoadingPitch && (
					<ContentCard>
						<CmsComponent structure={pitch} />
					</ContentCard>
				)}
				{!isLoadingDescription && (
					<ContentCard>
						<CmsComponent structure={description} />
					</ContentCard>
				)}
			</div>
		</Main>
	);
};
